import React from 'react';
import { classnames } from '../../../../utils/classnames';
import './style/chip.css';

export default function Chip({icon, text, color, style, textSize, ariaHidden = false}) {
    return (
        <div className={classnames('wz-chip', color)}>
		{icon && (
			<div className="wz-chip-icon">
				{icon}
			</div>
		)}
		{text && (
			<div
				aria-hidden={ariaHidden}
				style={{fontSize: textSize}}
				className='wz-chip-text'>
				{text}
			</div>
		)}
        </div>
    )
}